<template>
  <v-menu offset-y left>
    <template #activator="{ on, attrs }">
      <v-btn depressed color="primary" v-bind="attrs" v-on="on">
        <v-icon left small>mdi-export</v-icon>
        {{ $t("finance_nav_export") }}
        <v-icon right small>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item :disabled="disabled" @click="exportCsvFile">
        <v-list-item-icon class="mr-2"
          ><v-icon small>mdi-file-delimited-outline</v-icon></v-list-item-icon
        >
        <v-list-item-title>CSV</v-list-item-title>
      </v-list-item>
      <v-list-item @click="printPage">
        <v-list-item-icon class="mr-2"
          ><v-icon small>mdi-file-pdf-box</v-icon></v-list-item-icon
        >
        <v-list-item-title>PDF ({{ $t("print") }})</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { exportCsv } from "@/utils/csvExport";

// Izvoz (CSV/PDF) je dugme na ekranu, ne tab. Backend nema export endpoint -
// CSV se pravi od podataka koji su već na ekranu (getData -> { headers, rows }),
// a PDF je štampa stranice (browser "Save as PDF").
export default {
  name: "FinanceExportMenu",

  props: {
    filename: { type: String, required: true },
    getData: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    exportCsvFile() {
      const { headers, rows } = this.getData();
      exportCsv(this.filename, headers, rows);
    },
    printPage() {
      window.print();
    },
  },
};
</script>
